import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { GoogleMapsModule } from "@angular/google-maps";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutDirectiveModule } from './directives/flex-layout-directive.module';


// import { GlobalService } from './services/global.service';

import {
    AlertActionEntityDialogComponent, SidebarComponent, TopnavComponent, NavComponent, PageHeaderComponent, SnackBarComponent, ActionNotificationComponent, ConfirmInputEntityDialogComponent, AlertComponent,
    UpdateEntityDialogComponent, DeleteEntityDialogComponent, FetchEntityDialogComponent, UpdateStatusDialogComponent, AlertEntityDialogComponent, LoadingScreenComponent, ModalViewDialogComponent, EnumViewComponent, ErrorEntityDialogComponent, ConfirmEntityDialogComponent, ModalIframeDialogComponent, ModalUserDialogComponent, ModalDialogComponent, ModalPasswordDialogComponent, ModalUserViewDialogComponent, CustomSelectComponent, CustomTagsComponent, ModalIframeHeaderDialogComponent, ClientsAssignDialogComponent, CustomModalViewEventDialogComponent, CustomStartEndDateTimeComponent, ModalSchedulerExportDialogComponent, ModalUploaderDialogComponent
} from './components';
import { ModalFieldCropDialogComponent } from './components';

import { ModalGalleryDialogComponent } from './components';
import { ModalEmailDialogComponent, ModalVideoDialogComponent, ModalPagesDialogComponent, ModalEventMediaDialogComponent, ModalFormMediaDialogComponent, ModalEventDocumentDialogComponent, ModalCalenderDialogComponent, CustomSelectAutocompleteComponent, CustomSelectCreateAutocompleteComponent } from './components';

import { CustomMetadataTableComponent, CustomMultipleSelectComponent, CustomMultipleSelectTreeComponent, CustomSelectCreateAutocompleteDialogComponent, IframeUrlComponent, ModalLayoutDialogComponent, SliderComponent, CustomSelectDialogComponent, ModalCropDialogComponent, MarginViewComponent, CustomDateTimeComponent } from './components';
import { ClickOutSideDirective, OrdinalDatePipe } from './directives';
import { ConfirmSelectEntityDialogComponent, CustomSchedulerComponent, CustomSchedulerClientsComponent, CustomSchedulerAdminComponent } from './components';
// import { CkeditorBlockComponent, TextBlockComponent, LinkDescriptionBlockComponent, PictureBlockComponent, DisqusBlockComponent, SocialFeedBlockComponent, CalendarBlockComponent, PatientsBlockComponent, InquiryBlockComponent, SurveyBlockComponent, QuestionnaireBlockComponent, QuestionnaireSubOptionComponent, DescriptionSubOptionComponent, StartWrapperBlockComponent, AddSpaceComponent, FormTitleBlockComponent, QuestionsBlockComponent, ConfirmationBlockComponent, PasswordBlockComponent, NextBlockComponent, FormPhotoComponent, FormDocumentComponent, PainLevelComponent, DrawToolBlockComponent, PhysicianBlockComponent, EndWrapperBlockComponent, FillBlockComponent, NotesBlockComponent, ButtonsBlockComponent, ContactUsBlockComponent, PlacefullBlockComponent, AddToCartBlockComponent, CartBlockComponent, BlanksFormBlockComponent, ExclusiveUrlBlockComponent, FileUploadBlockComponent, PushpayBlockComponent, ThreedCartBlockComponent, BlogsBlockComponent, ChatBlockComponent, AccountBlockComponent, ProfileBlockComponent, TileSelectDialogComponent, TileDataComponent, TilesListComponent, CustomTileViewComponent, ConfirmCkeditorEntityDialogComponent, WidgetComponent, ModalPreviewDialogComponent } from './modules/forms-libararies';

import { Utils } from './helpers/utils';

import { ImageCropperModule } from 'ngx-image-cropper';
import { FileModalDialogComponent } from './components/custom-file-upload-dialog/custom-file-upload-dialog.component';
import { SimpleAlertEntityDialogComponent } from './components/modals/simple-entity-dialog/simple-entity-dialog.component';
import { CalendarModule } from './modules/calendar';
import { RecurrenceDialogComponent, ModalViewEventDialogComponent } from './modules/calendar';
import { MultipleModalDialogComponent } from './components/custom-multiple-upload-dialog/custom-multiple-upload-dialog.component';
import { ModalFilesEventDialogComponent } from './components/custom-files-event-dialog/custom-files-event-dialog.component';
import { ModalSendEmailDialogComponent } from './components/custom-send-email-dialog/custom-send-email-dialog.component';
// import { DeviceDetectorModule } from 'ngx-device-detector';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        TranslateModule,
        GoogleMapsModule,
        FormsModule,
        ReactiveFormsModule,
        ImageCropperModule,
        FlexLayoutDirectiveModule,
        CalendarModule,
        // Components (moved from declarations to imports for Angular 21)
        SidebarComponent,
        CustomSchedulerComponent,
        AlertActionEntityDialogComponent,
        TopnavComponent,
        NavComponent,
        PageHeaderComponent,
        SnackBarComponent,
        EnumViewComponent,
        ActionNotificationComponent,
        ConfirmInputEntityDialogComponent,
        ConfirmSelectEntityDialogComponent,
        ModalViewDialogComponent,
        AlertComponent,
        DeleteEntityDialogComponent,
        UpdateEntityDialogComponent,
        ErrorEntityDialogComponent,
        ConfirmEntityDialogComponent,
        SimpleAlertEntityDialogComponent,
        ModalIframeDialogComponent,
        ModalUserDialogComponent,
        FetchEntityDialogComponent,
        UpdateStatusDialogComponent,
        AlertEntityDialogComponent,
        LoadingScreenComponent,
        ModalDialogComponent,
        FileModalDialogComponent,
        ModalPasswordDialogComponent,
        ModalUserViewDialogComponent,
        CustomSelectComponent,
        CustomTagsComponent,
        ModalIframeHeaderDialogComponent,
        ModalGalleryDialogComponent,
        CustomSelectAutocompleteComponent,
        CustomSelectCreateAutocompleteComponent,
        CustomMetadataTableComponent,
        ModalEmailDialogComponent,
        ModalVideoDialogComponent,
        ModalPagesDialogComponent,
        ModalEventMediaDialogComponent,
        ModalFormMediaDialogComponent,
        ModalEventDocumentDialogComponent,
        ModalCalenderDialogComponent,
        CustomMultipleSelectComponent,
        CustomMultipleSelectTreeComponent,
        CustomSelectCreateAutocompleteDialogComponent,
        IframeUrlComponent,
        ModalLayoutDialogComponent,
        CustomSelectDialogComponent,
        SliderComponent,
        MarginViewComponent,
        CustomDateTimeComponent,
        ModalCropDialogComponent,
        ModalFieldCropDialogComponent,
        RecurrenceDialogComponent,
        ModalViewEventDialogComponent,
        CustomModalViewEventDialogComponent,
        ClientsAssignDialogComponent,
        CustomSchedulerClientsComponent,
        CustomSchedulerAdminComponent,
        CustomStartEndDateTimeComponent,
        ModalSchedulerExportDialogComponent,
        ModalUploaderDialogComponent,
        MultipleModalDialogComponent,
        ModalFilesEventDialogComponent,
        ModalSendEmailDialogComponent,
        // Directives and Pipes (now standalone)
        ClickOutSideDirective,
        OrdinalDatePipe
        // DeviceDetectorModule
    ],
    providers: [
        // GlobalService
        Utils
    ],
    exports: [
        SidebarComponent,
        CustomSchedulerComponent,
        AlertActionEntityDialogComponent,
        TopnavComponent,
        NavComponent,
        PageHeaderComponent,
        ActionNotificationComponent,
        ConfirmInputEntityDialogComponent,
        ConfirmSelectEntityDialogComponent,
        ModalViewDialogComponent,
        AlertComponent,
        DeleteEntityDialogComponent,
        UpdateEntityDialogComponent,
        ErrorEntityDialogComponent,
        ConfirmEntityDialogComponent,
        SimpleAlertEntityDialogComponent,
        ModalIframeDialogComponent,
        ModalUserDialogComponent,
        FetchEntityDialogComponent,
        UpdateStatusDialogComponent,
        AlertEntityDialogComponent,
        EnumViewComponent,
        LoadingScreenComponent,
        ModalDialogComponent,
        FileModalDialogComponent,
        ModalPasswordDialogComponent,
        ModalUserViewDialogComponent,
        CustomSelectComponent,
        // SpeakerCameraComponent,
        CustomTagsComponent,
        // TileWidgetComponent,
        ModalIframeHeaderDialogComponent,
        ModalGalleryDialogComponent,
        CustomSelectAutocompleteComponent,
        CustomSelectCreateAutocompleteComponent,
        CustomMetadataTableComponent,
        ModalEmailDialogComponent,
        ModalVideoDialogComponent,
        ModalPagesDialogComponent,
        ModalEventMediaDialogComponent,
        ModalFormMediaDialogComponent,
        ModalEventDocumentDialogComponent,
        ModalCalenderDialogComponent,
        CustomMultipleSelectComponent,
        CustomMultipleSelectTreeComponent,
        CustomSelectCreateAutocompleteDialogComponent,
        // TilesListComponent,
        IframeUrlComponent,
        // TileAnswersComponent,
        // TileAnswersPercentageComponent,
        // ModalTileCreateDialogComponent,
        // TileDataComponent,
        // LectureTilesListComponent,
        ModalLayoutDialogComponent,
        // BillboardSelectDialogComponent,
        CustomSelectDialogComponent,
        ClickOutSideDirective,
        OrdinalDatePipe,
        SliderComponent,
        MarginViewComponent,
        // LayoutRowDataComponent,
        CustomDateTimeComponent,
        ModalCropDialogComponent,
        ModalFieldCropDialogComponent,
        // EmojiFormComponent,
        // EmojiSliderFieldComponent,
        // FireworksBackgroundComponent,
        RecurrenceDialogComponent,
        ModalViewEventDialogComponent,
        CustomModalViewEventDialogComponent,
        ClientsAssignDialogComponent,
        CustomSchedulerClientsComponent,
        CustomSchedulerAdminComponent,
        CustomStartEndDateTimeComponent,
        ModalSchedulerExportDialogComponent,
        ModalUploaderDialogComponent,
        MultipleModalDialogComponent,
        ModalFilesEventDialogComponent,
        ModalSendEmailDialogComponent,
        FlexLayoutDirectiveModule
    ]
})
export class LayoutComponentModule { }
